import { z } from 'zod'

export const ProductPrice = z.object({
  id: z.number().int(),
  amount: z.number().int().optional(),
  currency: z.string().max(3).optional(),
  description: z.string().optional(),
  active: z.boolean().optional().default(true),
  default: z.boolean().optional().default(true),
  tax: z.number().optional()
})

export type ProductPrice = z.infer<typeof ProductPrice>
